module.exports = __webpack_public_path__ + "static/media/editarAzul.94dafeaa.svg";